import React, { useState } from "react";
import atomize from "@quarkly/atomize";

const HoverBlock = ({
	"showed-element-index": sid = 0,
	children,
	...rest
}) => {
	const [isHovered, setIsHovered] = useState(false);
	return <div {...rest}>
		      
		{React.Children.map(children, (child, index) => {
			if (!child) return child;
			const isShowedElement = parseInt(sid) === index;
			if (isShowedElement) return isHovered ? child : null;
			const {
				onMouseEnter,
				onMouseLeave
			} = child.props || {};
			return React.cloneElement(child, {
				onMouseEnter: (...args) => {
					setIsHovered(true);
					onMouseEnter && onMouseEnter(...args);
				},
				onMouseLeave: (...args) => {
					setIsHovered(false);
					onMouseLeave && onMouseLeave(...args);
				}
			});
		})}
		    
	</div>;
};

export default atomize(HoverBlock)({
	name: "HoverBlock",
	propInfo: {
		"showed-element-index": {
			control: "input",
			category: "Main"
		}
	}
});